import { deepEqual } from '../lib';

const updateObject = (previousObject, updated) => {
  if (deepEqual(previousObject, updated)) {
    return previousObject;
  }
  return Object.assign({}, previousObject, updated);
};

export default updateObject;